var map = {
	"./decidim/avatar-multiuser.png": 56051,
	"./decidim/brands/facebook.svg": 68507,
	"./decidim/brands/google.svg": 15634,
	"./decidim/brands/twitter-x.svg": 37139,
	"./decidim/cc-badge.png": 62705,
	"./decidim/decidim-logo.svg": 19233,
	"./decidim/default-avatar.svg": 98689,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 27031,
	"./decidim/icons.svg": 73632,
	"./decidim/pattern.png": 69123,
	"./decidim/placeholder-card-g.svg": 28224,
	"./decidim/placeholder-card-l.svg": 93547,
	"./decidim/placeholder.jpg": 53890,
	"./decidim/remixicon.symbol.svg": 72856,
	"./decidim/vendor/social-share-button/douban.svg": 91435,
	"./decidim/vendor/social-share-button/email.svg": 46916,
	"./decidim/vendor/social-share-button/facebook.svg": 20128,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 43028,
	"./decidim/vendor/social-share-button/hacker_news.svg": 81320,
	"./decidim/vendor/social-share-button/linkedin.svg": 90466,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 54283,
	"./decidim/vendor/social-share-button/pinterest.svg": 10146,
	"./decidim/vendor/social-share-button/reddit.svg": 85976,
	"./decidim/vendor/social-share-button/telegram.svg": 1453,
	"./decidim/vendor/social-share-button/tumblr.svg": 31850,
	"./decidim/vendor/social-share-button/twitter.svg": 31521,
	"./decidim/vendor/social-share-button/vkontakte.svg": 32683,
	"./decidim/vendor/social-share-button/wechat.svg": 66678,
	"./decidim/vendor/social-share-button/whatsapp.svg": 61230,
	"./decidim/vendor/social-share-button/x.svg": 34300,
	"./decidim/vendor/social-share-button/xing.svg": 79260
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7602;